
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft, CreditCard } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Get payment status from URL params
    const paymentId = searchParams.get('payment_id');
    const status = searchParams.get('status');
    const externalReference = searchParams.get('external_reference');

    console.log('Payment failure page params:', { paymentId, status, externalReference });

    toast.error('Pagamento não aprovado', { 
      description: 'Houve um problema com o seu pagamento. Tente novamente.' 
    });
  }, [searchParams]);

  return (
    <div className="max-w-2xl mx-auto space-y-8 animate-fade-in">
      <div className="text-center">
        <XCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-red-600">Pagamento Não Aprovado</h1>
        <p className="text-muted-foreground mt-2">
          Houve um problema com seu pagamento
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <XCircle className="h-5 w-5 text-red-600" />
            Pagamento Rejeitado
          </CardTitle>
          <CardDescription>
            Não foi possível processar seu pagamento. Tente novamente.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-red-50 p-4 rounded-lg border border-red-200">
            <h3 className="font-medium text-red-800 mb-2">Possíveis motivos:</h3>
            <ul className="text-sm text-red-700 space-y-1">
              <li>• Dados do cartão incorretos</li>
              <li>• Saldo insuficiente</li>
              <li>• Cartão bloqueado ou vencido</li>
              <li>• Problema temporário na operadora</li>
            </ul>
          </div>

          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Você pode tentar novamente com outro método de pagamento ou entrar em contato 
              com sua operadora de cartão para verificar possíveis bloqueios.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild className="flex-1">
              <Link to="/patient-dashboard">
                <CreditCard className="h-4 w-4 mr-2" />
                Tentar Novamente
              </Link>
            </Button>
            <Button variant="outline" asChild className="flex-1">
              <Link to="/schedule">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Nova Consulta
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentFailure;
